<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
    };
  },
  created () {
    if (localStorage['JWT_TOKEN']) {
      this.$store.dispatch('getUserPermissions');
    }
  }
};
</script>

<style lang="less">
@import url('./assets/styles/common/common.css');
.size { width: 100%; height: 100%; }
html,body{ .size; overflow: hidden; margin: 0; padding: 0; }
#app { .size; }
</style>
